import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../hooks/hooks';
import { deepCopy, updateNestedValue } from '../../../../common/services/common.service';
import PageLoader from '../../../../components/PageLoader';
import { selectTenantFunctionsListItems } from '../../../../redux/tenant-functions/selector';
import GlobalParsingRuleComponent from '../components/global-parsing-rule.component';
import { selectglobalParsingRulesQueryItems } from '../../../../redux/global-parsing-rules/selector';
import { globalParsingRules } from '../../../../redux/global-parsing-rules/action';

let currentChange: any = {}
const GlobalParsingRule = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectglobalParsingRulesQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const tenantfunctionsLists = useSelector(selectTenantFunctionsListItems)
  const [
    parsingRule,
    setParsingRule
  ] = useState<any>([])

  const [
    fieldConversions,
    setFieldConversions
  ] = useState<any>([])
  const fetchRecordById = () => {
    dispatch(globalParsingRules.query({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/service/global-parsing-rules/fetch-detail`, entity: 'globalParsingRules', jsonData:
      {
        Context: {},
        Records: [
          {
            "Id": parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  useEffect(
    () => {
      if (parmas?.id > 0) {
        fetchRecordById()
      }
      else {
        const localSelectedService = addNewRow({ selectedServiceArg: fieldConversions });
        setFieldConversions(localSelectedService)
      }
    }, [])

  useEffect(
    () => {
      if (isQuery) {
        setParsingRule(queryItems?.result?.items)
        const localSelectedService = addNewRow({ selectedServiceArg: queryItems?.result?.items?.Options?.FieldConversions });
        setFieldConversions(localSelectedService)
      }
    }, [isQuery])

  const handleInnerBasicFormChange: any = (event: any, field: string) => {
    setParsingRule({ ...parsingRule, [field]: event });
  }

  const handleInnerFormChange: any = ({ path, value }: any) => {
    const cloned = deepCopy(parsingRule); // need this to avoid mutation error
    const updatedData = updateNestedValue(cloned, path, value)
    setParsingRule({ ...updatedData });
  }

  const handleFormItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(fieldConversions);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setFieldConversions(items);
  }

  const deleteSelectedService = async (Item: any, index: any) => {
    const items = deepCopy(fieldConversions);// deep copy of grn items
    // if (Item.Id === 0) {
    items?.splice(
      index,
      1
    )
    // }
    setFieldConversions(items);

  }

  const addNewRow = ({ selectedServiceArg }: any) => {
    const localSelectedservice = deepCopy(selectedServiceArg)
    const newRowFieldConversion = {
      InputFieldIndex: null,
      InputFieldType: '',
      OutputFieldIndex: null,
      OutputFieldType: '',
      OutputHeaderText: ''
    }
    if (localSelectedservice.length === 0 ||
      localSelectedservice[localSelectedservice?.length - 1]?.OutputHeaderText !== ''
    ) {
      localSelectedservice?.push(newRowFieldConversion)
    }
    return localSelectedservice
  }

  const setCombinationInfo = async () => {
    let localSelectedService = deepCopy(fieldConversions)
    localSelectedService.splice(
      currentChange.idx,
      1,
      { ...localSelectedService[currentChange.idx] }
    );
    localSelectedService = addNewRow({ selectedServiceArg: localSelectedService });
    currentChange.field = 'OutputHeaderTextDONE'
    setFieldConversions(localSelectedService)
  }
  useEffect(
    () => {
      if (currentChange.field === 'OutputHeaderText') {
        setCombinationInfo()
      }
    },
    [fieldConversions]
  )

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    const localParsingRule = deepCopy(parsingRule)
    fieldConversions.splice(
      fieldConversions.length - 1,
      1
    )

    _.map(fieldConversions, (item, index) => {
      item.InputFieldIndex = index + 1;
      item.OutputFieldIndex = index + 1;
    })

    console.log('save data', {
      ...localParsingRule,
      OwnerType: localParsingRule?.OwnerType || "",
      Options: {
        ...localParsingRule.Options,
        InputFileHasHeader: localParsingRule?.Options?.InputFileHasHeader || false,
        OutputFileHasHeader: localParsingRule?.Options?.OutputFileHasHeader || false,
        FieldConversions: fieldConversions
      },
    })
    if (parmas?.id > 0) {
      dispatch(globalParsingRules.update({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/service/global-parsing-rules`,
        entity: 'globalParsingRules',
        jsonData:
        {
          "Context": {},
          Records: [
            {
              ...localParsingRule,
              Id: parmas?.id,
              OwnerType: localParsingRule?.OwnerType || "",
              Options: {
                ...localParsingRule.Options,
                InputFileHasHeader: localParsingRule?.Options?.InputFileHasHeader || false,
                OutputFileHasHeader: localParsingRule?.Options?.OutputFileHasHeader || false,
                FieldConversions: fieldConversions
              },
            }
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      dispatch(globalParsingRules.create({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/service/global-parsing-rules`,
        entity: 'globalParsingRules',
        jsonData:
        {
          "Context": {
          },
          Records: [
            {
              ...localParsingRule,
              Id: 0,
              Name: localParsingRule?.Name || "",
              OwnerType: localParsingRule?.OwnerType || "",
              Options: {
                ...localParsingRule.Options,
                InputFileHasHeader: localParsingRule?.Options?.InputFileHasHeader || false,
                OutputFileHasHeader: localParsingRule?.Options?.OutputFileHasHeader || false,
                FieldConversions: fieldConversions
              },
            }
          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const back = async () => {
    navigate(-1)
  }

  return (
    <>
      {tenantfunctionsLists?.isLoading || queryItems?.isLoading ? <PageLoader /> :
        <GlobalParsingRuleComponent
          handleInnerFormChange={handleInnerFormChange}
          parsingRule={parsingRule}
          handleFormSubmit={handleFormSubmit}
          back={back}
          deleteSelectedService={deleteSelectedService}
          handleFormItemChange={handleFormItemChange}
          handleInnerBasicFormChange={handleInnerBasicFormChange}
          tenantFunctions={tenantfunctionsLists?.result?.items}
          fieldConversions={fieldConversions}
        />}
    </>
  )

}

export default GlobalParsingRule;